<template>
  <div class="dados">
    <h4>Conectando...</h4>
  </div>
</template>

<script>
import { mapState } from "vuex";
import makeToast from "../../mixins/makeToast";

export default {
  name: "SimularAcesso",
  mixins: [makeToast],

  data() {
    return {
      id: null,
      voltarLogin: false
    }
  },

  computed: {
    ...mapState(['token', 'dadosUsuario'])
  },

  created() {
    const gerente = JSON.parse(localStorage.getItem('voltarLogin'))
    if(gerente && gerente == true) {
      this.voltarLogin = true;
      this.id = this.dadosUsuario.informacoes.usuario_id;
    } else {
      this.id = this.dadosUsuario.informacoes.lojista_id;
    }
    this.simularAcesso();
  },

  methods: {
    simularAcesso() {
      const data = {
        id: this.id,
        voltarLogin: this.voltarLogin,
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('gerente/simularAcesso', data)
        .then((data) => {
          this.$store.commit('setDadosUsuario', data.data.info);
          this.$store.commit('setToken', data.data.token);
          localStorage.setItem('dadosUsuario', JSON.stringify(data.data.info));
          localStorage.setItem('token', data.data.token);
          localStorage.setItem('voltarLogin', data.data.voltarLogin);
          if(this.voltarLogin == true) {
            this.$router.push({ name: 'gerente-meus-dados' });
          } else {
            this.$router.push({ name: 'lojista-meus-dados' });
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader')
        });
    },
  },
};
</script>

<style scoped>
.limpar {
  margin-left: 20px;
  color: #df0808;
  float: right;
  cursor: pointer;
  text-decoration: underline;
}
</style>
